import script from "./MenusMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenusMain.vue?vue&type=script&setup=true&lang=ts"

import "./MenusMain.vue?vue&type=style&index=0&id=24f7c2de&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f7c2de"]])

export default __exports__